// 以；分块
export function fenHaoArray (arr) {
    let k = []
    let asplit = arr.split('；')
    for(let i=0;i<asplit.length-1;i++){
        k.push(asplit[i] + ('；'))
    }
    k.push(asplit[asplit.length-1])
    return k
}

// 以（分块
export function kuoHaoArray (arr) {
    let k = []
    let asplit = arr.split('（')
    asplit.forEach((val)=>{
        k.push('（' + val)
    })
    k = k.splice(1)
    return k
}
